import { isVideoModel, VIDEO_MODES, type VideoMode, type VideoModel } from '@shared/index'
import { createFileRoute } from '@tanstack/react-router'

import VideoGenerationPage from '../pages/PageVideoGeneration'

type VideoGenerationSearch = { generationId?: string; retryGenerationId?: string; mode?: VideoMode; model?: VideoModel }

export function validateVideoGenerationSearch(search: Record<string, unknown>): VideoGenerationSearch {
  const uuid = (value: unknown) =>
    typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
      ? value
      : undefined
  return {
    model: typeof search.model === 'string' && isVideoModel(search.model) ? search.model : undefined,
    mode:
      typeof search.mode === 'string' && (VIDEO_MODES as readonly string[]).includes(search.mode)
        ? (search.mode as VideoMode)
        : undefined,
    generationId: uuid(search.generationId),
    retryGenerationId: uuid(search.retryGenerationId)
  }
}

export const Route = createFileRoute('/video-generation')({
  component: VideoGenerationPage,
  validateSearch: validateVideoGenerationSearch
})
